import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Route, Switch } from 'react-router-dom';

const Dashboards = asyncComponent(() => import('../dashboards'));
const DashMetasEquipe = asyncComponent(() =>
  import('../dashboards/Metas/Equipe/MetasEquipe')
);
const DashMetasEmpresa = asyncComponent(() =>
  import('../dashboards/Metas/Empresa/MetasEmpresa')
);
const DashMetasNegociador = asyncComponent(() =>
  import('../dashboards/Metas/Negociador/MetasNegociador')
);
const DashMetasConfiguracoes = asyncComponent(() =>
  import('../dashboards/Metas/Configuracoes/ListaConfiguracoes')
);

const DashMetasEmpresa02 = asyncComponent(() =>
  import('../dashboards/Metas02/Empresa02/MetasEmpresa02')
);
const DashMetasEquipe02 = asyncComponent(() =>
  import('../dashboards/Metas02/Equipe02/MetasEquipe02')
);
const DashMetasIndividual02 = asyncComponent(() =>
  import('../dashboards/Metas02/Individual02/MetasIndividual02')
);

const DashGerencialVisaoGeralCarteiras = asyncComponent(() =>
  import('../dashboards/Gerencial/VisaoGeralCarteiras/VisaoGeralCarteiras')
);
const DashGerencialGestaoAcordos = asyncComponent(() =>
  import('../dashboards/Gerencial/GestaoAcordos/GestaoAcordos')
);

export default function DashboardRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/dash/metas/config`}
          component={DashMetasConfiguracoes}
          codigo="dash.metas.config"
        />
        <PrivateRoute
          path={`${match.url}/dash/metas/empresa`}
          component={DashMetasEmpresa02}
          codigo="dash.metas.empresa"
        />
        <PrivateRoute
          path={`${match.url}/dash/metas/equipe`}
          component={DashMetasEquipe02}
          codigo="dash.metas.equipe"
        />
        <PrivateRoute
          path={`${match.url}/dash/metas/individual`}
          component={DashMetasIndividual02}
          codigo="dash.metas.individual"
        />

        <PrivateRoute
          path={`${match.url}/dash/gerencial/visao-geral-carteiras`}
          component={DashGerencialVisaoGeralCarteiras}
          codigo="dash.gerencial.geral_carteiras"
        />
        <PrivateRoute
          path={`${match.url}/dash/gerencial/gestao-acordos`}
          component={DashGerencialGestaoAcordos}
          codigo="dash.gerencial.gestao_acordos"
        />

        <PrivateRoute
          path={`${match.url}/dash/inicio`}
          component={Dashboards}
          codigo="modulo_dashboards"
        />
        <PrivateRoute
          exact
          path={`${match.url}/dash`}
          component={Dashboards}
          codigo="modulo_dashboards"
        />
      </Switch>
    </>
  );
}
